import { AUTH_TYPE } from 'feature/loading-management/utils/const';

// Same per-product options as the existing Edit Customer Auth drawer dropdown.
const PRODUCT_AUTH_TYPE_VALUES = ['UNLIMITED', 'LIMITED', 'MONTHLY', 'WEEKLY', 'DAILY', 'ONELOAD'];

export const PRODUCT_AUTH_TYPE_OPTIONS = AUTH_TYPE.filter(({ value }) =>
  PRODUCT_AUTH_TYPE_VALUES.includes(value)
);

export const isValidProductAuthType = value =>
  PRODUCT_AUTH_TYPE_OPTIONS.some(option => option.value === value);

export const getAuthTypeLabel = value =>
  AUTH_TYPE.find(option => option.value === value)?.label ?? value ?? '';

export const needsAuthorizationVolume = authorizationType =>
  ['LIMITED', 'MONTHLY', 'WEEKLY', 'DAILY', 'ONELOAD'].includes(authorizationType);

export const needsRenewalVolume = authorizationType =>
  ['MONTHLY', 'WEEKLY', 'DAILY'].includes(authorizationType);

// Strips non-numeric characters and leading zeros.
export const sanitizeVolumeInput = raw =>
  String(raw ?? '')
    .replace(/\D/g, '')
    .replace(/^0+/, '');

export const MAX_VOLUME_DIGITS = 14;

export const getVolumeError = value => {
  if (value === undefined || value === null || value === '' || Number.isNaN(value)) {
    return 'Required';
  }
  if (String(value).length > MAX_VOLUME_DIGITS) {
    return `Cannot exceed ${MAX_VOLUME_DIGITS} digits`;
  }
  if (Number(value) <= 0) {
    return 'Required';
  }
  return '';
};

// Alphanumeric-aware compare so '2' sorts before '10'.
export const compareProductIdns = (a, b) =>
  String(a ?? '').localeCompare(String(b ?? ''), undefined, { numeric: true, sensitivity: 'base' });

export const getProductId = product => product.productId ?? product.id;

export const getUniqueProducts = products => {
  const uniqueProducts = new Map();

  products.forEach(product => {
    const productId = getProductId(product);
    if (productId !== undefined && productId !== null) {
      uniqueProducts.set(String(productId), product);
    }
  });

  return [...uniqueProducts.values()];
};

// Normalizes the differing product shapes returned by the BE endpoints.
export const getProductRow = product => ({
  id: getProductId(product),
  pidx: product.pidx ?? product.pidxCode ?? product.pidxProd ?? product.pidxIdName ?? '--',
  productIdn: product.productIdName ?? product.productIdn ?? product.idn ?? product.idName ?? '--',
  productName:
    product.productNameLong ??
    product.productLongName ??
    product.productName ??
    product.nameLong ??
    product.productNameShort ??
    product.nameShort ??
    '--',
});
